// Determine if an item is selected
export default function includesSelectedArr (type, arr) {
  let isTrue = false;
  arr.map(item => {
    if (item.selected) {
      let selectedValue = item.value;
      // if developments has selectedValue then true
      if (type.includes(selectedValue)) {
        isTrue = true;
      }
    }
  })
  return isTrue;
}